export default {
	type: 'object',
	properties: {
		userId: { type: 'string' },
		projectId: { type: 'string' },
	},
	required: ['userId', 'projectId'],
	additionalProperties: false,
}
